import type { GatewayConfig } from '@/core/api/libraries.api'

export const isGatewayConfigAvailable = (config: GatewayConfig): boolean => Boolean(config.host?.trim())
